import Layzr from "layzr.js";
import { set } from "../../js/lib/util";

const instance = Layzr({
  normal: "data-normal",
  retina: "data-retina",
  srcset: "data-srcset",
  threshold: 0,
});

instance.on("src:before", (image) => {
  const onLoad = function () {
    let container = image.parentNode || false;

    if (!container) {
      return;
    }

    let sources = container.querySelectorAll("source");

    if (sources) {
      for (let source of sources) {
        if (source.hasAttribute("data-srcset")) {
          source.setAttribute(
            "srcset",
            source.getAttribute("data-srcset") || ""
          );
          source.removeAttribute("data-srcset");
        }
      }
    }

    if (container) {
      set(container, "is-loaded");
    }
  };

  /* For some reason, onLoad events are not firing on picture elements in Safari. */
  const fallbackEvent = setTimeout(onLoad, 500);

  image.onload = () => {
    onLoad();
    clearTimeout(fallbackEvent);
  };
});

window.layzr = instance;

export default (el) => {
  instance.update().check().handlers(true);
};
